export enum DividerVariantEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
